export default class LangResource {
    langKeys: string[] = [];
    messages: any = {}
}